import { render } from "./TopNav.vue?vue&type=template&id=6dc8d56a"
import script from "./TopNav.vue?vue&type=script&lang=js"
export * from "./TopNav.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/works/main/HelpDesk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__